import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons';

interface GitHubFileLinkProps {
  href: string;
  'aria-label': string;
  'data-testid': string;
  children: React.ReactNode;
}

/**
 * Anchor styled to match the md outline-primary PulseButton, for opening a
 * source file in GitHub in a new tab.
 */
const GitHubFileLink: React.FC<GitHubFileLinkProps> = ({
  href,
  'aria-label': ariaLabel,
  'data-testid': dataTestId,
  children,
}) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="inline-flex h-10 w-fit items-center justify-center gap-2 rounded-3xl border border-sky-600 bg-transparent px-3.5 text-sm font-bold text-sky-900 transition-colors duration-200 hover:bg-sky-50 focus:outline-none"
    aria-label={ariaLabel}
    data-testid={dataTestId}
  >
    {children}
    <Icon icon={faArrowUpRight} />
  </a>
);

export default GitHubFileLink;
